// src/router/config.tsx
import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const Home = lazy(() => import("../pages/home/page"));
const PostDetail = lazy(() => import("../pages/post-detail/page"));
const CategoryPage = lazy(() => import("../pages/category/page"));
const TagsPage = lazy(() => import("../pages/tags/page"));
const ArchivePage = lazy(() => import("../pages/archive/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },

  {
    path: "/post/:slug",
    element: <PostDetail />,
  },

  {
    path: "/category/:category",
    element: <CategoryPage />,
  },

  {
    path: "/tags/:tag",
    element: <TagsPage />,
  },

  {
    path: "/archive/:year/:month",
    element: <ArchivePage />,
  },

  {
    path: "/search",
    element: <ArchivePage />,
  },

  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
